<template>
  <form class="simulation-form form" @submit.prevent>
    <div :class="`simulation-form__user-info ${ ageErrorMessage  !== '' ? 'error' : '' }`">
      <label class="form__label">
        <span
          :class="`form__label-text simulation-form__user-age ${(age !== null && age !== '') && 'form__label-text--fullfiled'}`"
        >Informe a sua idade</span>
        <input
          class="form__input"
          type="number"
          :min="ageMin"
          name="age"
          v-model="age"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.age === false,
              icon__check : validation.age
            }"
          />
        </span>
        <span class="form__error-message">{{ ageErrorMessage }}</span>
      </label>
      <div :class="`simulation-form__gender-wrapper form__group--column ${(genderErrorMessage !== '') && 'error'}`">
        <label class="form__label--only">Gênero:</label>
        <div class="form__group">
          <input
            id="male"
            class="form__input--radio"
            type="radio"
            name="gender"
            v-model="gender"
            value="M"
            @change="handleGender"
          />
          <label for="male" class="form__label--radio">M</label>
          <input
            id="female"
            class="form__input--radio"
            type="radio"
            name="gender"
            v-model="gender"
            value="F"
            @change="handleGender"
          />
          <label for="female" class="form__label--radio">F</label>
        </div>
        <span class="form__error-message">{{ genderErrorMessage }}</span>
      </div>
    </div>
    <div class="grid__col-1--md">
      <label class="simulation-form__protections-wrapper form__label">
        <span class="form__label--only">
          Selecione o valor das suas proteções:
          <strong
            class="simulation-form__selected-protections-value form__label--emphasys"
          >R$ {{ selectedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }},00</strong>
        </span>
        <input
          :class="['form__input--range', setRangeBackgroundPercent]"
          :disabled="setDisableRange"
          type="range"
          name="selectedValue"
          v-model="selectedValue"
          :min="range.min"
          :max="range.max"
          :step="range.step"
          @change="handleRange"
        />
        <span class="form__error-message"></span>
      </label>
    </div>
  </form>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import insurersCalculations from "../../mixins/insurersCalculations";

export default {
  name: "SimulationForm",
  data() {
    return {
      age: null,
      ageErrorMessage: "",
      ageMin: 18,
      gender: "",
      genderErrorMessage: "",
      selectedValue: 0,
      range: {
        min: 0,
        max: 1000000,
        step: 50000
      },
      validation: {
        age: null
      }
    };
  },
  mixins: [insurersCalculations],
  computed: {
    ...mapGetters(["getInsurer"]),
    ...mapState(["simulation", "quotation"]),
    setRangeBackgroundPercent: function() {
      return `form__input--range-${parseInt((this.selectedValue / this.range.max) * 100)}`;
    },
    setDisableRange() {
      
      if(this.age === null) {
        return true;
      } else if (this.gender === "") {
        return true;
      }
      else {
        return false;
      }
    }
  },
  watch: {
    selectedValue(value) {
      if (value >= 400000) {
        this.range.min = this.range.step = 100000;
      } else {
        this.range.min = this.range.step = 50000;
      }
    }
  },
  methods: {
    ...mapActions([
      "setSimulationAge",
      "setSimulationStarted",
      "setSimulationValues",
      "setProtectionsValue",
      "setQuotationStep",
      "setUserState"
    ]),
    handleGender: function(event) {
      const payload = {
        event,
        group: "personalData"
      };
      this.setUserState(payload);
      if (this.simulation.started) {
        this.handleRange();
      }
      this.genderErrorMessage = "";
    },
    handleRange: function() {
      this.range.min = 50000;
      document.querySelector(".form__input--range").focus();
      const simulationForm = document.querySelector(".simulation-form");
      const header = document.querySelector(".header");
      if (!this.simulation.set && this.age !== null && this.age !== "" && this.gender !== "" && window.outerWidth < 768) {
        scrollTo(
          0,
          simulationForm.offsetTop +
            simulationForm.offsetHeight -
            (header.offsetHeight + 75)
        );
      }

      this.setSimulationStarted(true);
      if (!this.age) {
        this.ageErrorMessage = "Campo obrigatório para simulação";
      } else if(this.gender === "") {
        this.genderErrorMessage = "Campo obrigatório para simulação";
      } else if (this.age >= this.ageMin && this.gender !== "" && this.selectedValue > 0) {
        const infos = {
          age: this.age,
          gender: this.gender,
          selectedValue: this.selectedValue
        };
        let payload = [
          {
            id: "bradescoSeguros",
            value: this.calculateBradescoSeguros(
              infos,
              this.getInsurer("bradescoSeguros").table
            )
          },
          {
            id: "icatuSeguros",
            value: this.calculateIcatuSeguros(
              infos,
              this.getInsurer("icatuSeguros").table
            )
          },
          {
            id: "mongeralAegon",
            value: this.calculateMongeralAegon(
              infos,
              this.getInsurer("mongeralAegon").table
            )
          },
          {
            id: "portoSeguro",
            value: this.calculatePortoSeguro(
              infos,
              this.getInsurer("portoSeguro").table
            )
          }
        ];

        this.setSimulationValues(payload);
      }

      this.setProtectionsValue(this.selectedValue);
    },
    handleFocus: function({ target }) {
      const { previousElementSibling } = target;
      previousElementSibling.classList.add("form__label-text--focus");
    },
    handleInput: function({ target }) {
      const { value } = target;

      if (value === "" || value === null) {
        this.ageErrorMessage = "Campo obrigatório para simulação";
      } else {
        this.ageErrorMessage = "";
      }
    },
    handleBlur: function({ target }) {
      const { age, ageMin } = this;
      if (age === null || age === "") {
        this.ageErrorMessage = "Campo obrigatório para simulação";
        this.validation[target.name] = false;
      } else if (age < ageMin) {
        this.ageErrorMessage = "A idade mínima 18 anos";
        this.validation[target.name] = false;
      } else {
        this.ageErrorMessage = "";
        this.validation[target.name] = true;
        this.setSimulationAge(age);
      }
      if (this.simulation.started) {
        this.handleRange();
      }
    }
  },
  mounted() {
    const { personalData, financialData } = this.quotation.user;
    const { age } = this.simulation;
    this.setQuotationStep(0);
    
    this.age = age;
    this.gender = personalData.gender;
    this.selectedValue = financialData.protectionsValue;
    if(this.selectedValue > 0) {
      setTimeout(() => {
        if(this.simulation.set) {
          this.handleRange();
        }
      }, 500);
    }
  }
};
</script>

<style lang="scss">
.simulation-form {
  @include breakpoint($desk__min--sm) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: $space__st;
  }

  &__user {
    &-info {
      display: grid;
      grid-template-columns: 60% 40%;
      grid-gap: $space__st;
      align-items: center;

      .form {
        &__label {
          &-text {
            position: absolute;
            bottom: 50%;
            left: $space__sm;
            transition: all 0.2s ease-in;

            &--fullfiled,
            &--focus {
              bottom: 90%;
              left: 0;

              &:after {
                content: ":";
              }
            }
          }
        }
      }
    }
    &-age {
      color: $color__red;
      &.form__label-text--fullfiled {
        color: $color__black;
      }
    }
  }

  &__gender-wrapper {
    @include breakpoint($desk__min--sm) {
      align-items: center;
      justify-self: center;
    }
    &.error {
      margin-bottom: $space__sm;
      color: $color__red;
    }
  }

  &__protections-wrapper {
    &.form__label {
      margin-top: 0;
      margin-bottom: 0;
    }

    @include breakpoint($desk__min--sm) {
    }
  }

  &__range-attention {
    position: absolute;
    bottom: 20px;
    left: 100%;
    width: 30px;
    height: 23px;
    
      @include breakpoint($desk__min--sm) {
        left: 110%;
      }


    &--left {
      position: absolute;
      bottom: 20px;
      left: -10%;
      width: 30px;
      height: 23px;

      @include breakpoint($desk__min--sm) {
        display: none;
      }
    }
  }

  &__selected-protections-value {
    @include breakpoint("max-width: 475px") {
      display: block;
      padding: $space__sm 0;
    }
  }
}
</style>
